/*global jQuery */
(function($) {

  'use strict';

  $(function() {
    new Blazy({ selector: '.b-lazy' });

    $('.owl-carousel.bannerhome').owlCarousel({
      animateOut: 'fadeOut',
      mergeFit: true,
      responsiveRefreshRate: 200,
      margin: 0,
      loop: true,
      autoplay: true,
      autoplayTimeout: 3000,
      autoplayHoverPause: true,
      autoplaySpeed: 2000,
      items: 1,
      nav: true,
      navText: ['<div class="left carousel-control hidden-xs"><span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span></div>',
              '<div class="right carousel-control hidden-xs"><span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span></div>']
    });

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      $('.info_collezione').show();
    } else {
      $('.box_collezione').hover(function() {
        $('.info_collezione', this).stop().fadeIn();
      }, function() {
        $('.info_collezione', this).stop().fadeOut();
      });
    }

  });

}(jQuery));